module.exports = __webpack_public_path__ + "img/double-tick.svg";